import { render } from "./EditReturn.vue?vue&type=template&id=12c7fdce&ts=true"
import script from "./EditReturn.vue?vue&type=script&lang=ts"
export * from "./EditReturn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__